import "./MyApiKeysPage.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchMyApiKeys } from "../../redux/actions/apiKeys.actions";
import MyApiKeysContainer from "./components/MyApiKeysContainer";
import GenerateMyKeyModal from "./components/GenerateMyKeyModal";
import RevokeMyKeyModal from "./components/RevokeMyKeyModal";

const MyApiKeysPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const [generateOpen, setGenerateOpen] = useState(false);
  const [revokeOpen, setRevokeOpen] = useState(false);
  const [spaToModify, setSpaToModify] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchMyApiKeys());
  }, [dispatch]);

  return (
    <div className="page lp-page">
      <GenerateMyKeyModal open={generateOpen} setOpen={setGenerateOpen} object={spaToModify} />
      <RevokeMyKeyModal open={revokeOpen} setOpen={setRevokeOpen} object={spaToModify} />

      <Header header="My API Keys" />
      <main className="lp-main">
        <MyApiKeysContainer
          setGenerateOpen={setGenerateOpen}
          setRevokeOpen={setRevokeOpen}
          setSpaToModify={setSpaToModify}
        />
      </main>
    </div>
  );
};

export default MyApiKeysPage;
